import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";

import { DialogFooter } from "../../../components/DialogFooter";

interface ClockOutConfirmationProps {
  modalState: UseModalState;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ClockOutConfirmation(props: ClockOutConfirmationProps) {
  const { modalState, onConfirm, onCancel } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" sx={{ paddingTop: 10 }} onClose={onCancel}>
          <Button fullWidth variant="contained" size="large" onClick={onConfirm}>
            Continue
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="clock"
        title="Are you sure you want to clock out?"
      />
    </BottomSheet>
  );
}
